import { render, staticRenderFns } from "./CtaSection.vue?vue&type=template&id=c2cacb5a&scoped=true"
import script from "./CtaSection.vue?vue&type=script&lang=js"
export * from "./CtaSection.vue?vue&type=script&lang=js"
import style0 from "./CtaSection.vue?vue&type=style&index=0&id=c2cacb5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cacb5a",
  null
  
)

export default component.exports